import { FC } from "react";
import { Box } from "@mui/material";
import { PatientCaseTableCol, PatientCaseListType } from "./Data";
import ControlledTable from "Components/ControlledTable";
import { TableLayout } from "Layouts";

const PatientCases: FC<{
  data: PatientCaseListType[];
  loading: boolean;
}> = ({ data, loading }) => {
  const TblBodyJSX = (
    <ControlledTable.TblBody
      tableColumn={() => PatientCaseTableCol}
      tableRow={data}
    />
  );

  return (
    <Box sx={{ ...sxMain }}>
      <TableLayout
        tblBody={TblBodyJSX}
        tblHead={ControlledTable.TblHead(PatientCaseTableCol)}
        height={"95%"}
        loading={loading}
        pageRecordCount={data.length}
      />
    </Box>
  );
};

export default PatientCases;

const sxMain = {
  height: "100%",
  overflow: "auto",
  px: 2,
  "&>div": {
    pt: 2,
  },
};
